/* eslint-disable import/no-unused-modules */

import styled, { css, DefaultTheme } from 'styled-components'

interface TextProps {
  font?: keyof DefaultTheme['typography']['fontFamilies']
  color?: keyof DefaultTheme['colors']
  uppercase?: boolean
  size?: keyof DefaultTheme['typography']['fontSizes']
  weight?: keyof DefaultTheme['typography']['fontWeights']
  lineHeight?: number
  center?: boolean
  underline?: boolean
}

const Text = styled.div<TextProps>`
  ${({
    font,
    color,
    uppercase,
    weight,
    size,
    theme,
    lineHeight,
    center,
    underline,
  }) => css`
    display: inline;
    direction: rtl;
    color: ${
      color ? theme.colors[color as keyof DefaultTheme['colors']] || color : ''
    };
    text-align: ${center ? 'center' : null};
    text-transform: ${uppercase && 'uppercase'};
    font-family: ${theme.typography.fontFamilies[font || 'ElMessiriRegular']};
    font-size: ${theme.typography.fontSizes[size || 'medium']};
    font-weight: ${theme.typography.fontWeights[weight || 'regular']};
    text-decoration: ${underline ? 'underline' : 'none'};
    line-height: ${
      lineHeight ? `${lineHeight}px` : theme.typography.fontSizes[size || 'big']
    };
    @media (max-width: ${(props) => props.theme.responsive.tablet}) {
    font-size: ${
      size === 'small'
        ? theme.typography.fontSizes.verySmall
        : size === 'medium'
        ? theme.typography.fontSizes.small
        : size === 'big'
        ? theme.typography.fontSizes.medium
        : size === 'veryBig'
        ? theme.typography.fontSizes.big
        : size === 'biggest'
        ? theme.typography.fontSizes.veryBig
        : theme.typography.fontSizes.verySmall
    };
    
  `}
`

export default Text
